import { TUser } from 'types/user';

export const isDisplaySignUpForm = (user: TUser | undefined): boolean =>
    Boolean(user?.isAuthenticated && !user.isUser && user.email);
